// @flow
import * as React from 'react';
import { get } from 'lodash';
import { Button, ThemeContext, Text } from 'grommet';
import { FormattedMessage } from 'react-intl';

import { APIContext } from 'speed-js-react';


type Props = {
    fileAccessor: string,
    row: Object,
    icon: React.Node,
};

const S3DownloadComponent = (props: Props) => {
    const {
        fileAccessor,
        row,
        icon,
    } = props;

    const { apiClient } = React.useContext(APIContext);
    const [error, setError] = React.useState(null);
    const fileId = get(row, fileAccessor);

    const handleFileDownload = () => {
        setError(null);
        apiClient.resources.fileS3.getDownloadUrl(fileId).then((res) => {
            const resData = res.data;
            window.open(resData, '_blank');
        }).catch((err) => {
            const errMsg = (
                <FormattedMessage
                    id="document-download-error"
                    defaultMessage="An error occurred while downloading the file, please try again."
                />
            );
            setError(errMsg);
        });
    };

    const theme = {
        button: {
            border: {
                width: '2px',
                radius: '14px',
            },
            extend: () => `
                    padding: 8px;
                `,
        },
    };


    return (
        <ThemeContext.Extend
            value={theme}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',


                }}
            >
                {error && (
                    <Text
                        color="status-error"
                        size="small"
                        style={{
                            textAlign: 'center',
                            marginBottom: '10px',
                        }}
                    >
                        {error}
                    </Text>
                )}
                <Button
                    icon={icon}
                    onClick={handleFileDownload}
                    // Means the document does not have a file attached yet
                    disabled={!fileId}
                />
            </div>
        </ThemeContext.Extend>
    );
};

export default S3DownloadComponent;
